// src/apis/resourcesApis.ts

import { apiAxios } from "./api-config/apiConfig";

/* =====================================================
   TYPES
===================================================== */

export interface ResourceDocument {
  isActive: boolean;
  documentLink: string;
  documentType: "video" | "document" | "website";
  documentDuration?: string;
}

export interface ResourceDetails {
  id: string;
  name: string;
  thumbnail: string;
  altText: string;
  document: ResourceDocument[];
  description: string;
  categoryId: string;
  buttonName: string | null;
  isActive: boolean;
  categoryName: string;
  fileUrl: string;
  otherResources: any;
}

export interface ResourceDetailsResponse {
  status: boolean;
  data: ResourceDetails;
}

/* =====================================================
   API FUNCTION
===================================================== */

export const getResourceDetailsApi = async (
  resourceId: string,
): Promise<ResourceDetailsResponse> => {
  const response = await apiAxios.get<ResourceDetailsResponse>(
    `/resource/${resourceId}`,
  );

  return response.data;
};
